export default {
  "models": {
    "remark": "catatan",
  },

  "farms": {
    "plural": "tambak",
    "singular": "tambak",
  },
  "ponds": {
    "plural": "kolam",
    "singular": "kolam",
  },
  "cycles": {
    "plural": "siklus",
    "singular": "siklus",
  },

  "cyclePredictions": {
    "plural": "prediksi",
    "singular": "prediksi",

    "age": "DoC",
    "weight": "MBW (g)",
    "total_weight": "biomasa (kg)",
    "survival_rate": "SR (%)",
    "size": "size",
    "selling_price": "nilai jual",

    "pond": "kolam",
    "today": "hari ini",
    "total": "total"
  },
  "cycleActuals": {
    "plural": "aktual",
    "singular": "aktual"
  },

  "shrimpPrices": {
    "plural": "harga udang",
    "singular": "harga udang",

    "size": "size",
    "remark": "notes",
  },

  "multiMeasurements": {
    "plural": "kualitas air",
    "singular": "kualitas air",

    "id": "ID",
    "pond_id": "ID kolam",
    "cycle_id": "ID siklus",
    "measured_at": "diukur pada",

    "ph": "pH",
    "salinity": "salinitas",
    "temperature": "suhu",
    "do": "oksigen terlarut",
    "transparency": "kecerahan",
    "water_level": "ketinggian air",
    "do_percent": "persen oksigen terlarut",
    "ec": "konduktivatas elektrik",
    "tds": "jumlah padatan terlarut",
    "gravity": "gravitasi air laut",
    "color": "warna air",
    "weather": "cuaca",
    "turbidity": "turbiditas",
    "tom": "jumlah bahan organik",
    "ammonia": "amonia",
    "ammonium": "amonium",
    "total_ammonia": "total amonia",
    "nitrit": "nitrit",
    "nitrat": "nitrat",
    "phosphate": "fosfat",
    "bicarbonat": "bikarbonat",
    "carbonat": "karbonat",
    "alkalinity": "alkalinitas",
    "magnesium": "magnesium",
    "calcium": "kalsium",
    "hardness": "kesadahan",
    "potassium": "potassium / kalium",
    "orp": "potensial oksidasi-reduksi",
    "ga": "green algae",
    "bga": "blue green algae",
    "dino": "dinoflagellata",
    "diatom": "diatom",
    "euglenophyta": "euglenophyta",
    "haptyophyta": "haptyophyta",
    "gba": "gold brown algae",
    "gga": "golden green algae",
    "yga": "yellow green algae",
    "floc": "floc",
    "prozoo": "protozoa",
    "zoo": "zoo",
    "total_plankton": "total plankton",
    "yellow": "yellow vibrio",
    "green": "green vibrio",
    "luminance": "luminance",
    "black": "black vibrio",
    "total_vibrio": "total vibrio",
    "total_bacteria": "total bakteri",

    "temperature_short": "suhu",
    "salinity_short": "sal",
    "do_short": "DO",
    "ammonia_short": "NH3",
    "nitrat_short": "NO3",
    "nitrit_short": "NO2",
    "alkalinity_short": "alkalinity",
    "hardness_short": "hardness",
    "calcium_short": "Ca",
    "magnesium_short": "Mg",
    "carbonat_short": "CO3",
    "bicarbonat_short": "HCO3",
    "tom_short": "TOM",
    "orp_short": "ORP",
    "ammonium_short": "NH4",
    "phosphate_short": "PO4",
    "total_ammonia_short": "total NH3",
    "potassium_short": "potassium",
    "total_plankton_short": "total plankton",
    "ga_short": "GA",
    "bga_short": "BGA",
    "dino_short": "Dino",
    "diatom_short": "Diatom",
    "prozoo_short": "Prozoo",
    "floc_short": "Floc",
    "gba_short": "GBA",
    "euglenophyta_short": "Euglenophyta",
    "zoo_short": "Zoo",
    "haptyophyta_short": "Haptyophyta",
    "gga_short": "GGA",
    "yga_short": "YGA",
    "total_bacteria_short": "total bakteri",
    "total_vibrio_short": "total vibrio",
    "yellow_short": "yellow",
    "green_short": "green",
    "black_short": "black",
    "luminance_short": "luminance",

    "measured_date": "tanggal",
    "measured_time": "waktu",

    "cycle": "siklus",
    "pond": "kolam",
    "farm": "tambak",

    "waterQuality": "kualitas air",
    "chemical": "kimia",
    "plankton": "plankton",
    "microbiology": "mikrobiologi"
  },
  "waterQualityMultiMeasurements": {
    "plural": "kualitas air",
    "singular": "kualitas air"
  },
  "chemicalMultiMeasurements": {
    "plural": "kimia",
    "singular": "kimia"
  },
  "planktonMultiMeasurements": {
    "plural": "plankton",
    "singular": "plankton"
  },
  "microbiologyMultiMeasurements": {
    "plural": "mikrobiologi",
    "singular": "mikrobiologi"
  },
  "feeds": {
    "plural": "pakan",
    "singular": "pakan",

    "id": "ID",
    "cycle_id": "ID siklus",
    "stock_id": "ID stok",
    "quantity": "jumlah (kg)",
    "logged_at": "waktu",
    "remark": "catatan",

    "feed_at": "tanggal",
    "logged_date": "tanggal",
    "logged_time": "jam",
    "accumulation": "kumulatif (kg)",
    "age": "umur",
    "fasting": "puasa",

    "accumulation_short": "kumulatif (kg)",
    "remark_short": "ket",

    "cycle": "siklus",
    "pond": "kolam",
    "farm": "tambak",
    "stock": "stok"
  },
  "fastings": {
    "plural": "puasa",
    "singular": "puasa",

    "id": "ID",
    "cycle_id": "ID siklus",
    "logged_date": "tanggal",
    "fasting": "puasa",
    "remark": "catatan",

    "cycle": "siklus",
    "pond": "kolam",
    "farm": "tambak"
  },
  "feedingTrayControls": {
    "plural": "anco",
    "singular": "anco",

    "id": "ID",
    "logged_at": "waktu",
    "feed_logged_at": "waktu pakan",
    "cycle_id": "ID siklus",
    "tray_number": "no anco",
    "feed_remaining_percent": "persen sisa pakan",
    "remark": "catatan",

    "logged_time": "jam",
    "logged_date": "tanggal",
    "remark_short": "ket",

    "tray": "anco",
    "few": "sisa sedikit",
    "few_short": "SS",
    "empty": "habis",
    "empty_short": "H",
    "plenty": "sisa banyak",
    "plenty_short": "SB",
  },
  "samplings": {
    "plural": "sampling",
    "singular": "sampling",

    "id": "id",
    "cycle_id": "ID siklus",
    "average_weight": "MBW (g)",
    "survival_rate": "survival rate",
    "sampled_at": "tanggal",
    "remark": "catatan",

    "average_growth": "ADG",
    "adg": "ADG",
    "remark_short": "ket"
  },
  "treatments": {
    "plural": "perlakuan",
    "singular": "perlakuan",

    "id": "ID",
    "pond_id": "ID kolam",
    "stock_id": "ID stock",
    "name": "perlakuan",
    "quantity": "nilai",
    "treated_at": "tanggal",
    "remark": "catatan",

    "remark_short": "ket"
  },
  "harvests": {
    "plural": "panen",
    "singular": "panen",

    "id": "ID",
    "cycle_id": "ID siklus",
    "weight": "berat (kg)",
    "size": "size",
    "harvested_at": "tanggal",
    "selling_price": "harga jual",
    "status": "jenis",
    "remark": "catatan",
    "buyer": "pembeli",

    "price_per_kg": "harga per kg",
    "total_price": "total harga",

    "weight_short": "berat",
    "remark_short": "ket"
  },
  "mortalities": {
    "plural": "kematian",
    "singular": "kematian",

    "id": "ID",
    "cycle_id": "ID siklus",
    "quantity": "ekor",
    "average_weight": "MBW (g)",
    "recorded_at": "tanggal",
    "remark": "catatan",

    "size": "size",
    "total_weight": "berat (kg)",

    "total_weight_short": "berat",
    "remark_short": "note"
  },
  "cycleDiseases": {
    "plural": "penyakit",
    "singular": "penyakit",

    "id": "ID",
    "cycle_id": "ID siklus",
    "disease_id": "ID penyakit",
    "laboratory_id": "ID laboratorium",
    "other_disease": "penyakit lain",
    "logged_at": "waktu",
    "positive": "positive",
    "remark": "catatan",

    "logged_date": "tanggal",
    "logged_time": "jam",
    "image": "foto",

    "remark_short": "note",

    "disease": "penyakit"
  },

  "regions": {
    "plural": "wilayah",
    "singular": "wilayah",

    "outside_indonesia": "LUAR INDONESIA"
  },

  "autoFeederPond": {
    "plural": "auto feeder kolam",
    "singular": "auto feeder kolam",

    "id": "ID",
    "pond_id": "ID kolam",
    "auto_feeder_address": "alamat",
    "name": "nama",
    "mode": "mode",
    "debit": "debit",
    "state": "state",

    "ip": "IP",
    "startTime": "jam mulai",
    "endTime": "jam selesai",
    "onTime": "timer ON",
    "feeds": "pakan",
    "updatedAt": "diperbaharui pada",
    "uploadedAt": "diunggah pada",
    "lastOnAt": "waktu ON terakhir",

    "timesPerDay": "kali per hari",
    "timesPerPeriod": "lemparan per jam pakan",
    "intervalPerPeriod": "interval per periode",
    "intervalPeriod": "durasi pakan",

    "feedsPerDay": "pakan per hari",

    "updated": "memperbaharui",
    "uploaded": "mengunggah",
    "created": "membuat"
  },
}
